import formatters from '@/services/authorization/formatters'
import { setAuthToken } from '@/services/http'
import storage from '@/utils/browser/storage'
import { jwtDecode } from 'jwt-decode'
import envs from '@envs'
import { setAttribute } from '@/utils/newRelic'

const _sendProspect = async ({ body }) => {
  const fetchResponse = await fetch(`${envs.API_BASE_URL}/prospect`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  }).then((res) => res)

  if (!fetchResponse.ok) {
    return {
      error: {
        code: fetchResponse.status,
        message: fetchResponse.message
      }
    }
  }

  const responseData = await fetchResponse.json()

  const responseHaveAuth = responseData?.authToken

  setAttribute({
    auth_token: responseHaveAuth
  })

  if (responseHaveAuth) {
    const decoded = jwtDecode(responseHaveAuth)
    setAttribute({
      lead_uuid: decoded.lead_uuid
    })

    storage.session.setItem('lead', {
      uuid: decoded.lead_uuid,
      ...body
    })

    await setAuthToken(
      formatters.auth({
        access_token: responseData.authToken,
        created_at: responseData.createdAt,
        expires_in: responseData.expiresIn
      })
    )

    return {
      ...responseData,
      lead_uuid: decoded.lead_uuid
    }
  }

  return {
    ...responseData
  }
}

export default {
  post: _sendProspect
}
